interface IconProps {
  size?: number;
  color?: string;
}

export function ConsoleIcon({ size = 24, color = 'currentColor' }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="6" width="20" height="12" rx="3" />
      <line x1="6" y1="10" x2="6" y2="14" />
      <line x1="4" y1="12" x2="8" y2="12" />
      <circle cx="16" cy="11" r="0.5" fill={color} />
      <circle cx="18" cy="13" r="0.5" fill={color} />
    </svg>
  );
}
